import { type FC } from 'react';
import { connect } from 'react-redux';

import { t } from '@grafana/i18n';
import { reportInteraction } from '@grafana/runtime';
import { ToolbarButton } from '@grafana/ui';
import { contextSrv } from 'app/core/services/context_srv';
import { type DashboardModel } from 'app/features/dashboard/state/DashboardModel';
import { registerDynamicDashNavAction } from 'app/features/dashboard-scene/utils/registerDynamicDashNavAction';

import { AccessControlAction, type EnterpriseStoreState } from '../../types';
import { setDrawerOpen } from '../state/reducers';

import AnalyticsDrawer from './AnalyticsDrawer';

type AnalyticsContentProps = {
  dashboard?: DashboardModel;
  isDrawerOpen: boolean;
  setDrawerOpen: typeof setDrawerOpen;
};

const AnalyticsContent: FC<AnalyticsContentProps> = ({ dashboard, isDrawerOpen, setDrawerOpen }) => {
  const showContent = Boolean(dashboard?.uid && dashboard.meta.url);

  return (
    showContent && (
      <>
        <ToolbarButton
          icon="info-circle"
          tooltip={t('meta-analytics.analytics-toolbar-button.tooltip-dashboard-insights', 'Dashboard insights')}
          onClick={() => {
            setDrawerOpen(true);
            reportInteraction('dashboards_toolbar_actions_clicked', { item: 'insights' });
          }}
        />
        {isDrawerOpen && dashboard && <AnalyticsDrawer dashboard={dashboard} />}
      </>
    )
  );
};

function mapStateToProps(state: EnterpriseStoreState) {
  return {
    isDrawerOpen: state.metaAnalytics.isDrawerOpen,
  };
}

const mapDispatchToProps = {
  setDrawerOpen,
};

export const initAnalyticsDrawer = () => {
  if (!contextSrv.hasPermission(AccessControlAction.DashboardsInsightsRead)) {
    return;
  }

  registerDynamicDashNavAction('right', {
    show: () => true,
    component: connect(mapStateToProps, mapDispatchToProps)(AnalyticsContent),
    index: -1,
  });
};
